module.exports = __webpack_public_path__ + "img/notice.9aed569f.png";